import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _isNativeReflectConstruct from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/isNativeReflectConstruct";
import _getPrototypeOf from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DynamicListingComponent.css';
import React from 'react';
import { get } from '../../utils';
import { withRouter } from 'react-router-dom';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import FilterBlock from './FilterBlock';
import FeaturedResultItem from './FeaturedResultItem';
import SeeMoreButton from './SeeMoreButton';
import ResultItem from './ResultItem';
import { pick } from '../../utils';
import LoadMore from './LoadMore';
import { qsToObject } from '../../utils/querystring';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import { addQueryStringMultiple, splitter } from "../Listing";
export var FacetWidgetType = /*#__PURE__*/function (FacetWidgetType) {
  FacetWidgetType["MULTI_TOGGLE"] = "multiToggle";
  FacetWidgetType["SINGLE_TOGGLE"] = "singleToggle";
  FacetWidgetType["MULTI_SELECT"] = "multiSelect";
  FacetWidgetType["SINGLE_SELECT"] = "singleSelect";
  return FacetWidgetType;
}({});

// Because we are trying to cover three content types via one component, we ask for all possible
// index properties and mark as optional those which might not be in curtain types.
// E.h. Legislations do not have headerimage property, but PressReleases do.

// @see graphQl definition

// @see graphQl definition

var getFilterFromCheckboxes = function getFilterFromCheckboxes(filtersArray) {
  var filtersFromCheckboxes = {};

  // eslint-disable-next-line array-callback-return
  filtersArray.map(function (filterDefinition) {
    if (filterDefinition.taxonomyType) {
      filtersFromCheckboxes[filterDefinition.taxonomyType.targetItem.filterName.value] = filtersFromCheckboxes[filterDefinition.taxonomyType.targetItem.filterName.value] || [];
      filtersFromCheckboxes[filterDefinition.taxonomyType.targetItem.filterName.value].push(filterDefinition.filterValue.value);
    }
  });
  return filtersFromCheckboxes;
};

/**
 * This is universal component that covers cases like:
 *  - List of Articles (specify via settingsItem.indexSource.targetItem.indexName.value)
 *  - List of PressReleases
 *  - List of Legislations
 *  - Optional UI Filter block if sitecore provides settingsItem.indexSource.targetItem.availableFacets
 *  - Featured items highlight if sitecore provides settingsItem.numberOfFeaturedItems.value
 *  - Predefined or Context-based default filtration
 *  - Optional Load more button
 *  - Optional "Go to full list" button
 *  - etc
 */
var DynamicListingComponent = /*#__PURE__*/function (_React$Component) {
  function DynamicListingComponent() {
    var _this;
    _classCallCheck(this, DynamicListingComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DynamicListingComponent, [].concat(args));
    _defineProperty(_this, "state", {
      hits: [],
      facets: {},
      nbHits: 0,
      nbPages: 0,
      filters: {},
      page: 0,
      algoliaModule: null
    });
    _defineProperty(_this, "context", void 0);
    _defineProperty(_this, "setFilters", function (filters) {
      var url = new URL(window.location.href);
      for (var filter in _this.state.filters) {
        url.searchParams.delete(filter);
      }
      _this.props.history.push("".concat(url.pathname).concat(url.search).concat(url.hash));
      if (Object.keys(filters).length) {
        for (var facet in filters) {
          addQueryStringMultiple(facet, filters[facet], _this.props.history);
        }
      } else {
        _this.props.history.push("".concat(url.pathname).concat(url.hash));
      }
      _this.setState({
        filters: filters,
        // Reset pagination, because we are going to show completely new set of results and nbHits will be different.
        page: 0
      });
    });
    _defineProperty(_this, "loadMore", function () {
      if (_this.state.page < _this.state.nbPages) {
        _this.setState(function (prevState) {
          return {
            page: prevState.page + 1
          };
        });
      }
    });
    _defineProperty(_this, "getMergedValidatedFilters", function () {
      var language = _this.context.language || 'en';
      var contextItem = _this.props.fields.data.contextItem;
      var queryParams = qsToObject(_this.props.location.search);
      var hasPredefinedFilters = Boolean(_this.props.fields.data.settingsItem.filterBy);
      var predefinedFiltersArray = hasPredefinedFilters ? _this.props.fields.data.settingsItem.filterBy.targetItems : [];
      var predefinedFilters = getFilterFromCheckboxes(predefinedFiltersArray);
      var contextFiltersArray = contextItem ? Object.keys(contextItem).map(function (itemName) {
        if (contextItem[itemName].targetItem) {
          return [contextItem[itemName].targetItem];
        } else if (contextItem[itemName].targetItems) {
          return contextItem[itemName].targetItems;
        }
        return [];
      }).flat(2) : [];
      var contextFilters = getFilterFromCheckboxes(contextFiltersArray);
      var availableFilterNamesForIndex = _this.props.fields.data.settingsItem.indexSource.targetItem.availableFilters.targetItems.map(function (filterDefinition) {
        return filterDefinition.filterName ? filterDefinition.filterName.value : '';
      }).filter(function (str) {
        return !!str;
      });

      // Filter only by allowed filters, to avoid empty search results or other problems.
      // After we merge language, filters from facets, and from component configuration, remove those which are not allowed.
      var result = _objectSpread({
        _language: [language]
      }, pick(_objectSpread(_objectSpread(_objectSpread({}, _this.state.filters), predefinedFilters), contextFilters), availableFilterNamesForIndex));

      // If there is tags in URL, lets add it as default filter.
      if (queryParams.tags) {
        result.tags = [].concat(_toConsumableArray(result.tags || []), [queryParams.tags]).filter(function (value, index, self) {
          return self.indexOf(value) === index;
        });
      }
      return result;
    });
    _defineProperty(_this, "loadSearchResults", function () {
      var settingsItem = get(_this.props, 'fields.data.settingsItem');
      if (!settingsItem) {
        return;
      }
      var algoliaModule = _this.state.algoliaModule;
      if (!algoliaModule) {
        console.warn('Algolia module not loaded');
        return;
      }
      var indexNameSuffix = settingsItem.indexSource.targetItem.indexName.value;
      var numberOfListItems = Number(settingsItem.numberOfListItems.value);
      var hasFacets = Boolean(settingsItem.indexSource.targetItem.availableFacets);
      var facetsSchema = hasFacets ? settingsItem.indexSource.targetItem.availableFacets.targetItems : [];
      // List of facet names, which will require separate query to fetch proper amount of items.
      var activeMultiSelectableFacets = [];
      var facetNames = facetsSchema.map(function (item) {
        if (
        // Only include if facet is being actively filtered now, otherwise it contains maximum amount of items.
        _this.state.filters[item.facetName.value]) {
          activeMultiSelectableFacets.push(item.facetName.value);
        }
        return item.facetName.value;
      });
      var featuredItemsQty = settingsItem.numberOfFeaturedItems ? Number(settingsItem.numberOfFeaturedItems.value) : 0;
      var amountOfResultsToFetch = featuredItemsQty + numberOfListItems;

      // Direct client is required for multiQueries search
      algoliaModule.getClient().then(function (client) {
        // @todo handle different errors from Algolia.

        var commonSearchArguments = {
          indexName: algoliaModule.getFullIndexName(indexNameSuffix),
          query: ''
        };
        var language = _this.context.language || 'en';

        // filtering results to exclude the current page by item id
        var currentPageId = "".concat(language, "_").concat(get(_this.props, 'route.itemId', ''));
        var resultsQueries = [_objectSpread(_objectSpread({}, commonSearchArguments), {}, {
          params: {
            facetFilters: algoliaModule.getFiltersFromCheckboxes(_this.getMergedValidatedFilters()),
            filters: currentPageId ? "NOT objectID:".concat(currentPageId.toLowerCase()) : '',
            // we hardcore attributes to retrieve, because react components hardly depends on them.
            attributesToRetrieve: ['pagetitle', 'pageintro', 'category', '__updated', 'dateofissue', 'isfeatured', 'businessunit', 'announcementtype', 'author', 'location', '_id', 'headerimage', 'url'],
            hitsPerPage: amountOfResultsToFetch,
            facets: facetNames,
            page: _this.state.page
          }
        })];

        // Each active facet requires additional light search request to fetch all available amounts
        // eslint-disable-next-line array-callback-return
        activeMultiSelectableFacets.map(function (facetName) {
          resultsQueries.push(_objectSpread(_objectSpread({}, commonSearchArguments), {}, {
            params: {
              // Facet amounts has to respect filters from other facets, because by default other facets are
              // applied with AND condition.
              facetFilters: algoliaModule.getFiltersFromCheckboxes(_this.getMergedValidatedFilters(), facetName),
              facets: [facetName],
              hitsPerPage: 1,
              attributesToRetrieve: [],
              attributesToHighlight: [],
              page: 0
            }
          }));
        });
        return client.search(resultsQueries).then(function (response) {
          var results = response.results;
          var pureFacets = {};
          var _results$ = results[0],
            facets = _results$.facets,
            hits = _results$.hits,
            nbHits = _results$.nbHits,
            nbPages = _results$.nbPages;

          // Fetch proper facet amounts from additional searches.
          // eslint-disable-next-line array-callback-return
          activeMultiSelectableFacets.map(function (facetName, index) {
            if (results[index + 1].facets && results[index + 1].facets[facetName]) {
              pureFacets[facetName] = results[index + 1].facets[facetName];
            }
          });
          _this.setState(function (prevState) {
            return {
              hits: _this.state.page === 0 ? hits : [].concat(_toConsumableArray(prevState.hits), _toConsumableArray(hits)),
              facets: _objectSpread(_objectSpread({}, facets), pureFacets),
              nbHits: nbHits,
              nbPages: nbPages
            };
          });
        }).catch(function (err) {
          console.error(err);
          // @todo should we just fallback to previous results?
          _this.setState({
            hits: [],
            facets: {},
            nbHits: 0,
            nbPages: 0
          });
        });
      }).catch(function (err) {
        // something happened during client initialization or shortly thereafter
        console.error(err);
      });
    });
    return _this;
  }
  _inherits(DynamicListingComponent, _React$Component);
  return _createClass(DynamicListingComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var filters = {};
      if (Array.from(this.props.location.search).length) {
        var search = new URLSearchParams(this.props.location.search);
        search.forEach(function (value, key) {
          filters[key] = value.split(splitter);
        });
      }
      this.setState({
        filters: filters
      });
      import(/* webpackChunkName: "AlgoliaModule" */'../../utils/algolia').then(function (mod) {
        _this2.setState(_objectSpread(_objectSpread({}, _this2.state), {}, {
          algoliaModule: mod.default
        }));
        _this2.loadSearchResults();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, nextContext) {
      // There is dependency on context.language as well, however it should not change without
      // full page reload, so we can avoid it here, because componentDidUpdate can not work with it anyway.

      if (this.state.filters !== prevState.filters || this.state.page !== prevState.page || this.props.fields.data.settingsItem !== prevProps.fields.data.settingsItem || this.props.fields.data.contextItem !== prevProps.fields.data.contextItem) {
        this.loadSearchResults();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var settingsItem = get(this.props, 'fields.data.settingsItem');
      if (!settingsItem) {
        console.info("[DynamicListingComponent] settings item wasn't resolved. returning from render.");
        return null;
      }
      var _this$props$fields$da = this.props.fields.data,
        bannerClickAnalytics = _this$props$fields$da.bannerClickAnalytics,
        listingItemAnalytics = _this$props$fields$da.listingItemAnalytics,
        seeMoreAnalytics = _this$props$fields$da.seeMoreAnalytics,
        filtersClickAnalytics = _this$props$fields$da.filtersClickAnalytics,
        fitlersCategoryAnalytics = _this$props$fields$da.fitlersCategoryAnalytics,
        fitlersClearAnalytics = _this$props$fields$da.fitlersClearAnalytics,
        fitlersValueAnalytics = _this$props$fields$da.fitlersValueAnalytics,
        filtersShowResultsAnalytics = _this$props$fields$da.filtersShowResultsAnalytics,
        featuredReadMoreAnalytics = _this$props$fields$da.featuredReadMoreAnalytics,
        listingLoadMoreAnalytics = _this$props$fields$da.listingLoadMoreAnalytics,
        featuredBannerClickAnalytics = _this$props$fields$da.featuredBannerClickAnalytics,
        featuredTitleClickAnalytics = _this$props$fields$da.featuredTitleClickAnalytics,
        listingBannerClickAnalytics = _this$props$fields$da.listingBannerClickAnalytics,
        listingTitleClickAnalytics = _this$props$fields$da.listingTitleClickAnalytics,
        eventsAnalytics = _this$props$fields$da.eventsAnalytics;
      var params = get(this.props, 'params');
      var viewedNofMLabel = get(settingsItem, 'viewedNofMLabel.value', "You've viewed {#loadedHits#} of {#nbHits#} items");
      var showNResultsLabel = get(settingsItem, 'showNResultsLabel.value', 'Show {#resultsAmount#} results');
      var cancelLabel = get(settingsItem, 'cancelLabel.value', 'Cancel');
      var clearAllButtonLabel = get(settingsItem, 'clearAllButtonLabel.value', 'Clear All');
      var clearButtonLabel = get(settingsItem, 'clearButtonLabel.value', 'Clear');
      var filtersButtonLabel = get(settingsItem, 'filtersButtonLabel.value', 'Filters');
      var hasFacets = Boolean(settingsItem.indexSource.targetItem.availableFacets);
      var facetsSchema = hasFacets ? settingsItem.indexSource.targetItem.availableFacets.targetItems : [];
      var isColoured = Boolean(settingsItem.colourTheme.targetItem);
      var featuredItemsQty = settingsItem.numberOfFeaturedItems ? Number(settingsItem.numberOfFeaturedItems.value) : 0;
      var rtl = Boolean(this.context && this.context.rtl);
      var pageEditing = Boolean(this.context && this.context.pageEditing);
      var hasItems = Boolean(this.state.hits && this.state.hits.length);
      var featuredItems = hasItems ? this.state.hits.slice(0, featuredItemsQty).filter(function (hit) {
        return hit.isfeatured;
      }) : [];
      var items = hasItems && this.state.hits.length > featuredItems.length ? this.state.hits.slice(featuredItems.length) : [];

      // To render three elements per row and keep proper layout.
      var groupedItems = items.reduce(function (rows, item, index) {
        index % 3 === 0 ? rows.push([item]) : rows[rows.length - 1].push(item);
        return rows;
      }, []);
      if (!hasItems) {
        return pageEditing ? /*#__PURE__*/React.createElement("div", null, "There are no search results. Most likely taxonomy settings are too restrictive or no results for current language.") : null;
      }
      return /*#__PURE__*/React.createElement(StyledWrapper, {
        anchorUrlParameter: params['Anchor Url Parameter']
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(commonStyle)
      }, this.state.facets && Object.keys(this.state.facets).length > 0 && /*#__PURE__*/React.createElement(FilterBlock, {
        facetsSchema: facetsSchema,
        facets: this.state.facets,
        setFilters: this.setFilters,
        resultsAmount: this.state.nbHits,
        filters: this.state.filters,
        showNResultsLabel: showNResultsLabel,
        cancelLabel: cancelLabel,
        clearAllButtonLabel: clearAllButtonLabel,
        clearButtonLabel: clearButtonLabel,
        filtersButtonLabel: filtersButtonLabel,
        filtersClickAnalytics: filtersClickAnalytics,
        fitlersCategoryAnalytics: fitlersCategoryAnalytics,
        fitlersClearAnalytics: fitlersClearAnalytics,
        fitlersValueAnalytics: fitlersValueAnalytics,
        filtersShowResultsAnalytics: filtersShowResultsAnalytics,
        params: params,
        rtl: rtl
      }), featuredItems.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "news-featured".concat(settingsItem.title ? ' news-featured--has-heading' : '').concat(isColoured ? ' news-featured--highlighted' : '', " ").concat(settingsItem.title.value === '' ? 'news-featured--no-heading' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "news-featured__highlighter"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-xl-11"
      }, /*#__PURE__*/React.createElement("div", {
        className: "news-featured__heading-sec"
      }, settingsItem.title && /*#__PURE__*/React.createElement(Text, {
        className: "h2 news-featured__heading",
        tag: "h2",
        field: settingsItem.title
      })))), featuredItems.length > 0 && featuredItems.slice(0, 1).map(function (item) {
        return /*#__PURE__*/React.createElement(FeaturedResultItem, {
          key: item.__updated,
          item: item,
          rtl: rtl,
          readFeaturedLabel: settingsItem.readFeaturedLabel,
          language: _this3.context.language,
          analytics: {
            data: {
              featuredReadMoreAnalytics: featuredReadMoreAnalytics,
              featuredBannerClickAnalytics: featuredBannerClickAnalytics,
              featuredTitleClickAnalytics: featuredTitleClickAnalytics,
              eventsAnalytics: eventsAnalytics
            },
            params: params
          }
        });
      })), featuredItems.length > 1 && featuredItems.slice(1, featuredItems.length).map(function (item) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.__updated,
          className: "news-featured"
        }, /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xl-1"
        }), /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-xl-11"
        }, /*#__PURE__*/React.createElement("div", {
          className: "news-featured__heading-sec"
        }))), /*#__PURE__*/React.createElement(FeaturedResultItem, {
          item: item,
          rtl: rtl,
          readFeaturedLabel: settingsItem.readFeaturedLabel,
          language: _this3.context.language,
          analytics: {
            data: {
              featuredReadMoreAnalytics: featuredReadMoreAnalytics,
              featuredBannerClickAnalytics: featuredBannerClickAnalytics,
              featuredTitleClickAnalytics: featuredTitleClickAnalytics,
              eventsAnalytics: eventsAnalytics
            },
            params: params
          }
        }));
      })), featuredItems.length === 0 && settingsItem.title && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-xl-11"
      }, /*#__PURE__*/React.createElement(Text, {
        className: "h3 news__heading-multiple",
        tag: "h3",
        field: settingsItem.title
      }))), hasItems && /*#__PURE__*/React.createElement(React.Fragment, null, groupedItems.map(function (rowItems, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "row",
          key: "results-row-".concat(index)
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-xl-1"
        }), rowItems.map(function (item) {
          return /*#__PURE__*/React.createElement(ResultItem, {
            item: item,
            key: item._id,
            language: _this3.context.language,
            analitycs: {
              listingItemAnalytics: listingItemAnalytics,
              bannerClickAnalytics: bannerClickAnalytics
            },
            params: params
          });
        }), /*#__PURE__*/React.createElement("div", {
          className: "col-xl-2"
        }));
      }), settingsItem.listingPage && settingsItem.seeMoreLabel && /*#__PURE__*/React.createElement(SeeMoreButton, {
        listingPage: settingsItem.listingPage,
        seeMoreLabel: settingsItem.seeMoreLabel,
        rtl: rtl,
        pageEditing: pageEditing,
        analitycs: seeMoreAnalytics,
        params: params
      }), settingsItem.loadMoreLabel && this.state.nbPages - 1 > this.state.page && /*#__PURE__*/React.createElement(LoadMore, {
        buttonLabel: settingsItem.loadMoreLabel.value,
        onClick: function onClick() {
          _this3.loadMore();
          tealiumClickFunc(tealiumMergeClickData(listingLoadMoreAnalytics, params));
        },
        nbHits: this.state.nbHits,
        loadedHits: this.state.hits.length,
        viewedNofMLabel: viewedNofMLabel
      }))));
    }
  }]);
}(React.Component);
DynamicListingComponent.contextType = SitecoreContextReactContext;
var commonStyle = "c1mwupbq";
var featuredResultItemStylesLtr = "f1tm4b59";
var featuredResultItemStylesRtl = "f12qtyxw";
var resultItemStylesLtr = "r1pju169";
var resultItemStylesRtl = "rnje00p";
export var loadMoreButtonStylesLtr = "l9grpxt";
var loadMoreButtonStylesRtl = "l1uzvc3v";
export var filtersStylesLtr = "f1s5tic2";
export var filtersStylesRtl = "f1dbvngk";
var toggleMultiSelectStylesLtr = "t1xylat4";
var toggleMultiSelectStylesRtl = "t1s7nib9";
var toggleSingleSelectStylesLtr = "t14hk01b";
var toggleSingleSelectStylesRtl = "t15ikf69";
var baseStylesLtr = "b1mp6ke4";
var baseStylesRtl = "b13pp662";
var ltrStylesCLasses = "\n".concat(baseStylesLtr, "\n").concat(featuredResultItemStylesLtr, "\n").concat(filtersStylesLtr, "\n").concat(loadMoreButtonStylesLtr, "\n").concat(resultItemStylesLtr, "\n").concat(toggleMultiSelectStylesLtr, "\n").concat(toggleSingleSelectStylesLtr, "\n");
var rtlStylesCLasses = "\n".concat(baseStylesRtl, "\n").concat(featuredResultItemStylesRtl, "\n").concat(filtersStylesRtl, "\n").concat(loadMoreButtonStylesRtl, "\n").concat(resultItemStylesRtl, "\n").concat(toggleMultiSelectStylesRtl, "\n").concat(toggleSingleSelectStylesRtl, "\n");
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl,
    anchorUrlParameter = _ref.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(rtl ? rtlStylesCLasses : ltrStylesCLasses, " ").concat(legislationStyles)
  }, children);
};
var legislationStyles = "l1hqfnau";
export default withRouter(DynamicListingComponent);